import { NgClass, NgForOf } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { MetaDataService } from '../../meta-data.service';
import { BaseActionComponent } from '../base-action.component';
import { Period, PeriodPostFix } from './period';

@Component({
  selector: 'app-action-replace-relative',
  templateUrl: './replace-relative.component.html',
  imports: [
    MatRadioGroup,
    MatRadioButton,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatSelect,
    MatOption,
    NgForOf
  ],
  styleUrls: ['../action.component.scss']
})
export class ReplaceRelativeComponent extends BaseActionComponent {

  relativePostFixes: IDateRelativePostFix[] = [
    {value: PeriodPostFix.D, viewValue: 'Day(s)'},
    {value: PeriodPostFix.W, viewValue: 'Week(s)'},
    {value: PeriodPostFix.M, viewValue: 'Month(s)'},
    {value: PeriodPostFix.Y, viewValue: 'Year(s)'},
  ];

  amountControl: FormControl;
  postFixControl: FormControl;
  periodControl: FormControl;
  nowControl: FormControl;
  private dynamicPeriod: Period;
  private readonly ZERO_PERIOD: Period = new Period(0, 0);
  private readonly DEFAULT_PERIOD = new Period(1, PeriodPostFix.D);
  private savedPeriod: Period;

  constructor(protected metaDataService: MetaDataService) {
    super(metaDataService);
  }

  protected initialiseControls() {
    this.amountControl = new FormControl();
    this.postFixControl = new FormControl();
    this.periodControl = new FormControl();
    this.nowControl = new FormControl();
    this.formGroup.removeControl('value');
    this.formGroup.addControl('value', this.periodControl);
  }

  protected initialise() {
    this.savedPeriod = this.actionData.value ? Period.parse(this.actionData.value) : new Period(0, 0);
    if (this.savedPeriod.amount === 0) {
      this.nowControl.setValue('now');
      this.periodControl.setValue(this.ZERO_PERIOD.output());
      this.dynamicPeriod = this.DEFAULT_PERIOD;
      this.postFixControl.setValue(this.dynamicPeriod.postFix.valueOf());
      this.amountControl.setValue(this.dynamicPeriod.amount);
    } else {
      this.nowControl.setValue('dynamic');
      this.dynamicPeriod = this.savedPeriod;
      this.periodControl.setValue(this.dynamicPeriod.output());
      this.amountControl.setValue(this.dynamicPeriod.amount);
      this.postFixControl.setValue(this.dynamicPeriod.postFix.valueOf());
    }
    this.subscribeToUIChanges();
  }

  private subscribeToUIChanges(): void {
    this.amountControl.valueChanges.subscribe(value => this.amountChangeHandler(value));
    this.postFixControl.valueChanges.subscribe(value => this.postFixChangeHandler(value));
    this.nowControl.valueChanges.subscribe(value => this.nowChangeHandler(value));
  }

  private amountChangeHandler(value: number): void {
    this.dynamicPeriod.amount = value;
    this.periodControl.setValue(this.dynamicPeriod.output());
    this.nowControl.setValue('dynamic');
    this.valueControl.markAsDirty();
  }

  private postFixChangeHandler(value: PeriodPostFix) {
    this.dynamicPeriod.postFix = value;
    this.periodControl.setValue(this.dynamicPeriod.output());
    this.nowControl.setValue('dynamic');
    this.valueControl.markAsDirty();
  }

  private nowChangeHandler(value: string) {
    if (value === 'now') {
      this.valueControl.markAsDirty();
      this.periodControl.setValue(this.ZERO_PERIOD.output());
    } else {
      this.valueControl.markAsDirty();
      this.periodControl.setValue(this.dynamicPeriod.output());
    }
  }
}

interface IDateRelativePostFix {
  value: PeriodPostFix;
  viewValue: string;
}
